import { render, staticRenderFns } from "./OsbModal.vue?vue&type=template&id=c0d231c2&scoped=true&lang=html&"
import script from "./OsbModal.vue?vue&type=script&lang=js&"
export * from "./OsbModal.vue?vue&type=script&lang=js&"
import style0 from "./OsbModal.vue?vue&type=style&index=0&id=c0d231c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0d231c2",
  null
  
)

export default component.exports